import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { fetchUserState } from '../ApiHandler/usersFunctions';
import { handleAddSchool, handleEditSchoolData, fetchStates, fetchDistricts } from '../ApiHandler/schoolFunctions';
import ViewSchools from './ViewSchools';

const AddSchool = ({ role, editFormData, handleClose }) => {
    const isEditing = !!editFormData;
    const [userState, setUserState] = useState("");
    const [schoolData, setSchoolData] = useState({
        schoolName: editFormData ? editFormData.school_name || "" : "",
        udise: editFormData ? editFormData.udise || "" : "",
        state: editFormData ? editFormData.state || "" : "",
        district: editFormData ? editFormData.district_id || "" : "",
        pincode: editFormData ? editFormData.pincode || "" : "",
        address: editFormData ? editFormData.address || "" : "",
        geoLocation: editFormData ? editFormData.geo_location || "" : "",
        schoolEmail: editFormData ? editFormData.contact_email || editFormData.school_email_id || "" : "",
        contactPerson: editFormData ? editFormData.principal_name || editFormData.primary_contact_person || "" : "",
        contactNo: editFormData ? editFormData.contact_phone || editFormData.contact_no || "" : "",
        totalStudents: editFormData ? editFormData.total_students || "" : ""
    });
    const [states, setStates] = useState([]);
    const [districts, setDistricts] = useState([]);

    useEffect(() => {
        fetchUserState(setUserState);
        fetchStates(setStates);
        // Fetch districts unconditionally since we need them for the dropdown
        fetchDistricts('all', setDistricts);
        if (editFormData && (editFormData.state || editFormData.state_name)) {
            // Already fetching all districts, no need to duplicate
        }
    }, [editFormData]);

    // Sync userState with schoolData.state when role is not 1
    useEffect(() => {
        if (role !== 1 && userState) {
            setSchoolData((prevData) => ({
                ...prevData,
                state: userState,
            }));
            fetchDistricts(userState, setDistricts);

        }
    }, [role, userState]);

    
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (isEditing) {
            const mappedData = {
                school_name: schoolData.schoolName,
                udise: schoolData.udise,
                district: schoolData.district,
                address: schoolData.address,
                school_email_id: schoolData.schoolEmail,
                contact_no: schoolData.contactNo,
                primary_contact_person: schoolData.contactPerson,
                school_type: schoolData.schoolType || "",
                pincode: schoolData.pincode,
                geo_location: schoolData.geoLocation,
                total_students: schoolData.totalStudents
            };
            await handleEditSchoolData(e, editFormData.id, mappedData);
            if (handleClose) handleClose();
        } else {
            handleAddSchool(e, schoolData, setSchoolData);
        }
    };

    const handleChange = async (e) => {
        const { name, value } = e.target;

        setSchoolData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === "state") {
            await fetchDistricts(value, setDistricts);
        }
    };

    const handleGetLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                const { latitude, longitude } = position.coords;
                setSchoolData(prevData => ({
                    ...prevData,
                    geoLocation: `${latitude}, ${longitude}`
                }));
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    };

    return (
        <div className="upload-document-container">
            <ToastContainer />
            <header className="upload-document-header">
                <h1>{isEditing ? 'Edit School Data' : 'Add School'}</h1>
            </header>
            <form className="upload-document-form" onSubmit={handleFormSubmit}>
                <div className='in-row-input'>
                    <div className="form-group">
                        <label>School Name <span style={{ color: 'red' }}>*</span></label>
                        <input
                            type="text"
                            name="schoolName"
                            value={schoolData.schoolName}
                            onChange={handleChange}
                            maxLength={150}
                            placeholder="Enter School Name"
                            autoComplete='off'
                            required
                        />
                        <label style={{ color: 'red', fontWeight: '350', fontSize: '12px' }}>Maximum Characters: 150</label>
                    </div>
                    <div className="form-group">
                        <label>UDISE <span style={{ color: 'red' }}>*</span></label>
                        <input
                            type="text"
                            name="udise"
                            value={schoolData.udise}
                            onChange={(e) => {
                                if (/^\d{0,11}$/.test(e.target.value)) {
                                    handleChange(e);
                                }
                            }}
                            placeholder="Enter UDISE"
                            autoComplete="off"
                            required
                        />
                    </div>

                </div>
                <div className='in-row-input'>
                    {(role === 1 ? (
                        <div className="form-group">
                            <label>State <span style={{ color: 'red' }}>*</span></label>
                            <select
                                name="state"
                                value={schoolData.state}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select State</option>
                                {states.map((state, index) => (
                                    <option key={index} value={state}>
                                        {state}
                                    </option>
                                ))}
                            </select>
                        </div>
                    ) : (
                        <div className="form-group">
                            <label>State <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="text"
                                name="state"
                                value={userState}
                                onChange={handleChange}
                                readOnly
                                required
                            />
                        </div>
                    ))}
                    <div className="form-group">
                        <label>District <span style={{ color: 'red' }}>*</span></label>
                        <Select 
                            options={districts.map(d => ({ value: d.id, label: d.district_name }))}
                            placeholder="Select District"
                            value={districts.map(d => ({ value: d.id, label: d.district_name })).find(o => o.value === schoolData.district) || null}
                            onChange={(selected) => setSchoolData(p => ({ ...p, district: selected ? selected.value : '' }))}
                            isClearable
                            required
                        />
                    </div>
                </div>
                <div className='in-row-input'>
                    <div className="form-group">
                        <label>Pincode <span style={{ color: 'red' }}>*</span></label>
                        <input
                            type="text"
                            name="pincode"
                            value={schoolData.pincode}
                            onChange={(e) => {
                                if (/^\d{0,6}$/.test(e.target.value)) {
                                    handleChange(e);
                                }
                            }}
                            placeholder="Enter Pincode"
                            autoComplete='off'
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Address <span style={{ color: 'red' }}>*</span></label>
                        <input
                            type="text"
                            name="address"
                            value={schoolData.address}
                            onChange={handleChange}
                            placeholder="Enter School Address"
                            autoComplete='off'
                            required
                        />
                    </div>
                </div>
                <div className='in-row-input'>
                    <div className="form-group geo-location-container">
                        <label>Geo Location</label>
                        <input
                            type="text"
                            name="geoLocation"
                            value={schoolData.geoLocation}
                            onChange={handleChange}
                            placeholder="Longitude and Latitude"
                            autoComplete='off'
                        />
                        <a href="# " type="button" className="get-location-button" onClick={handleGetLocation}><i className='bx bx-map-pin' ></i></a>
                    </div>
                    <div className="form-group">
                        <label>School Email ID</label>
                        <input
                            type="email"
                            name="schoolEmail"
                            value={schoolData.schoolEmail}
                            onChange={handleChange}
                            placeholder="Enter School Email ID (Optional)"
                            autoComplete='off'
                        />
                    </div>
                </div>
                <div className='in-row-input'>
                    <div className="form-group">
                        <label>Primary Contact Person <span style={{ color: 'red' }}>*</span></label>
                        <input
                            type="text"
                            name="contactPerson"
                            value={schoolData.contactPerson}
                            onChange={handleChange}
                            maxLength={75}
                            placeholder="Primary Contact Person"
                            autoComplete='off'
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Contact No <span style={{ color: 'red' }}>*</span></label>
                        <input
                            type="tel"
                            name="contactNo"
                            value={schoolData.contactNo}
                            onChange={handleChange}
                            placeholder="Primary Contact Person"
                            autoComplete='off'
                            maxLength={10}
                            required
                        />
                    </div>
                </div>
                <div className='in-row-input'>
                    <div className="form-group">
                        <label>Total Students <span style={{ color: 'red' }}>*</span></label>
                        <input
                            type="text"
                            inputMode="numeric"
                            name="totalStudents"
                            value={schoolData.totalStudents}
                            onChange={(e) => {
                                if (/^\d{0,4}$/.test(e.target.value)) {
                                    handleChange(e);
                                }
                            }}
                            placeholder="Enter total no of students"
                            autoComplete='off'
                            required
                        />
                    </div>
                    <div className="form-group">
                    </div>
                </div>
                <div className="form-group">
                    <button type="submit">{isEditing ? 'Update' : 'Submit'}</button>
                    {isEditing && <button type="button" onClick={handleClose} style={{marginLeft: '10px', backgroundColor: '#6c757d'}}>Cancel</button>}
                </div>
            </form>
            
            {/* Show My Entries at the bottom only if not editing */}
            {!isEditing && (
                <div style={{ marginTop: '40px' }}>
                    <ViewSchools role={role} showAllEntities={false} />
                </div>
            )}
        </div>
    );
};

export default AddSchool;
